import { createAsyncThunk } from '@reduxjs/toolkit';

import type { ICategoryCategory, IPerson } from '@/Module/Auth/Model/DataModel';
import { AuthService } from '@/Module/Auth/Service';

export const authGetCategoryByGradeIdAction = createAsyncThunk<ICategoryCategory[], IPerson['gradeId']>(
  'auth/getCategoryBuGradeId',
  async (gradeId, { signal }) => {
    return AuthService.getCategoryByGradeId(gradeId, signal).then(({ data }) => data.data);
  },
);
